import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'app.containers.Checklist.GeneralConditions.title',
    defaultMessage: 'Condições gerais',
  },
  descriptionTitle: {
    id: 'app.containers.Checklist.GeneralConditions.descriptionTitle',
    defaultMessage: 'Verifique se a condição do imóvel condiz com a descrição abaixo:',
  },
  propertyDescriptionTitle: {
    id: 'app.containers.Checklist.GeneralConditions.propertyDescriptionTitle',
    defaultMessage: 'Descreva melhor o imóvel (opcional):',
  },
  propertyDescriptionPlaceholder: {
    id: 'app.containers.Checklist.GeneralConditions.propertyDescriptionPlaceholder',
    defaultMessage: 'Insira a descrição sobre o imóvel aqui…',
  },
  saveGeneralConditions: {
    id: 'app.containers.Checklist.GeneralConditions.saveGeneralConditions',
    defaultMessage: 'Salvar condições gerais',
  },
  invalid: {
    id: 'app.containers.Checklist.GeneralConditions.invalid',
    defaultMessage: 'Preencha todos os itens',
  },
  maintenanceConditionDescriptionFirstElementIndexZeroLabel: {
    id: 'app.containers.Checklist.GeneralConditions.maintenanceConditionDescriptionFirstElementIndexZeroLabel',
    defaultMessage: 'Todos os cômodos estão com uma boa aparência geral, com móveis, armários e componentes novos.',
  },
  maintenanceConditionDescriptionFirstElementIndexOneLabel: {
    id: 'app.containers.Checklist.GeneralConditions.maintenanceConditionDescriptionFirstElementIndexOneLabel',
    defaultMessage: 'Todos os itens presentes no imóvel aparentam estar em perfeito estado: não estão manchados, '
    + 'enferrujados trincados e/ou quebrados - desde móveis, decoração, até paredes, pisos, acabamentos e janelas.',
  },
  maintenanceConditionDescriptionFirstElementIndexTwoLabel: {
    id: 'app.containers.Checklist.GeneralConditions.maintenanceConditionDescriptionFirstElementIndexTwoLabel',
    defaultMessage: 'Não precisa de nenhum ajuste nos itens presentes para que o inquilino se mude.',
  },
  maintenanceConditionDescriptionFirstElementIndexThreeLabel: {
    id: 'app.containers.Checklist.GeneralConditions.maintenanceConditionDescriptionFirstElementIndexThreeLabel',
    defaultMessage: 'A pintura é nova, sem manchas, mofos, rachaduras ou infiltrações.',
  },
  maintenanceConditionDescriptionFirstElementIndexFourLabel: {
    id: 'app.containers.Checklist.GeneralConditions.maintenanceConditionDescriptionFirstElementIndexFourLabel',
    defaultMessage: 'Imóvel pode ser mobiliado ou não.',
  },
  maintenanceConditionDescriptionSecondElementIndexZeroLabel: {
    id: 'app.containers.Checklist.GeneralConditions.maintenanceConditionDescriptionSecondElementIndexZeroLabel',
    defaultMessage: 'Alguns cômodos precisam de reformas pontuais, ou possuem mobília com aparência antiga.',
  },
  maintenanceConditionDescriptionSecondElementIndexOneLabel: {
    id: 'app.containers.Checklist.GeneralConditions.maintenanceConditionDescriptionSecondElementIndexOneLabel',
    defaultMessage: 'A pintura precisa ser restaurada - está manchada, antiga ou suja.',
  },
  maintenanceConditionDescriptionSecondElementIndexTwoLabel: {
    id: 'app.containers.Checklist.GeneralConditions.maintenanceConditionDescriptionSecondElementIndexTwoLabel',
    defaultMessage: 'Alguns componentes do imóvel precisam de reparos ou serem instalados - desde maçanetas, '
    + 'torneiras, luminárias, espelhos e pias até piso, janelas, armários e móveis.',
  },
  maintenanceConditionDescriptionSecondElementIndexThreeLabel: {
    id: 'app.containers.Checklist.GeneralConditions.maintenanceConditionDescriptionSecondElementIndexThreeLabel',
    defaultMessage: 'Um bom estado de conservação, mas precisa de poucos ajustes para receber um inquilino.',
  },
  maintenanceConditionDescriptionThirdElementIndexZeroLabel: {
    id: 'app.containers.Checklist.GeneralConditions.maintenanceConditionDescriptionThirdElementIndexZeroLabel',
    defaultMessage: 'Imóvel no contrapiso.',
  },
  maintenanceConditionDescriptionThirdElementIndexOneLabel: {
    id: 'app.containers.Checklist.GeneralConditions.maintenanceConditionDescriptionThirdElementIndexOneLabel',
    defaultMessage: 'Sem itens essenciais como piso, pintura e acabamentos, até armários, gabinetes, chuveiro '
    + 'e espelho no banheiro.',
  },
  maintenanceConditionDescriptionThirdElementIndexTwoLabel: {
    id: 'app.containers.Checklist.GeneralConditions.maintenanceConditionDescriptionThirdElementIndexTwoLabel',
    defaultMessage: 'Imóvel não consegue receber um inquilino sem ser reformado ou receber grandes ajustes.',
  },
  maintenanceConditionDescriptionFourthElementIndexZeroLabel: {
    id: 'app.containers.Checklist.GeneralConditions.maintenanceConditionDescriptionFourthElementIndexZeroLabel',
    defaultMessage: 'Os componentes do imóvel estão em mal estado de conservação - visivelmente com defeito, '
    + 'quebrados, trincados, manchados, com sinais de mal uso ou emperrados - desde móveis, decoração, até '
    + 'paredes, pintura, pisos, acabamentos e janelas.',
  },
  maintenanceConditionDescriptionFourthElementIndexOneLabel: {
    id: 'app.containers.Checklist.GeneralConditions.maintenanceConditionDescriptionFourthElementIndexOneLabel',
    defaultMessage: 'Presença de infiltrações, rachaduras, vazamentos, mofo e/ou cupins.',
  },
  maintenanceConditionDescriptionFourthElementIndexTwoLabel: {
    id: 'app.containers.Checklist.GeneralConditions.maintenanceConditionDescriptionFourthElementIndexTwoLabel',
    defaultMessage: 'O imóvel precisa ser completamente reformado antes de receber um inquilino.',
  },
  maintenanceConditionDescriptionFifthElementIndexZeroLabel: {
    id: 'app.containers.Checklist.GeneralConditions.maintenanceConditionDescriptionFifthElementIndexZeroLabel',
    defaultMessage: 'Imóvel em bom estado, mas com componentes visivelmente antigos (pintura, azulejos, '
    + 'louças do banheiro e cozinha, decoração, etc.)',
  },
  maintenanceConditionDescriptionFifthElementIndexOneLabel: {
    id: 'app.containers.Checklist.GeneralConditions.maintenanceConditionDescriptionFifthElementIndexOneLabel',
    defaultMessage: 'Imóvel possui componentes como: mobília antiquada com cores fortes, móveis embutidos, '
    + 'box de acrílico, azulejos estampados.',
  },
});

